module.exports = __webpack_public_path__ + "img/title-5mg.f113b35d.png";